import PropTypes from 'prop-types';
import React from 'react';
import styles from './ProductSection.scss';
import { Product } from '../../models';

export default class ProductSection extends React.PureComponent {
  static propTypes = {
    model: PropTypes.instanceOf(Product),
    merchantName: PropTypes.bool,
    brandName: PropTypes.bool,
    categoryName: PropTypes.bool,
  };

  static defaultProps = {
    merchantName: false,
    brandName: false,
    categoryName: false,
  };

  state = {
    expanded: false,
  };
  collapsedContent: ?HTMLDivElement;
  scrollCollapsedContentIntoView: boolean;

  toggleDetails = (scrollIntoView?: boolean) => {
    this.scrollCollapsedContentIntoView = scrollIntoView === true;
    this.setState(prevState => ({ expanded: !prevState.expanded }));
  };

  componentDidUpdate(prevProps: Props, prevState: State) {
    // scroll collapsed content into view when expanding
    if (
      prevState.expanded !== this.state.expanded &&
      this.state.expanded === true
    ) {
      this.scrollCollapsedContentIntoView &&
        this.collapsedContent &&
        this.collapsedContent.scrollIntoView();
    }
  }

  renderAttributes(props) {
    const {
      model: { merchant, brand_name, category_name },
      merchantName,
      brandName,
      categoryName,
    } = props;
    const listItems = [
      {
        value: merchantName === true ? merchant.name || merchant.id : null,
        label: 'Merchant',
        dataKey: 'merchant_name',
      },
      {
        value: brandName === true ? brand_name : null,
        label: 'Brand',
        dataKey: 'brand_name',
      },
      {
        value: categoryName === true ? category_name : null,
        label: 'Category',
        dataKey: 'category_name',
      },
    ].map(props => {
      const { value, label, dataKey } = props;

      return Boolean(value) ? (
        <li className={styles.productSectionPropsListItem} key={label}>
          <strong className={styles.productSectionPropsListItemLabel}>
            {`${label}: `}
          </strong>
          <span
            data-key={dataKey}
            className={styles.productSectionPropsListItemText}
            data-translate={false}
          >
            {value}
          </span>
        </li>
      ) : null;
    });

    return (
      <ul className={styles.productSectionPropsList} data-translate={true}>
        {listItems}
      </ul>
    );
  }

  render() {
    const {
      name: product_name,
      product_url,
      product_image_url: { thumbnail: product_image_url },
      brand_name,
      description: product_description,
      page_id,
      page_id_variant,
      associated_products,
    } = this.props.model;

    return (
      <section
        className={styles.productSection}
        ref={c => (this.collapsedContent = c)}
      >
        <div className={styles.productSectionInfo}>
          <img
            className={styles.productSectionImage}
            src={product_image_url}
            alt={product_name}
            width="60"
            height="60"
          />
          <div className={styles.productSectionProps}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <h1
                className={`${styles.productSectionTitle} ${
                  Boolean(product_url) ? styles.productSectionTitleLinked : ''
                }`}
              >
                {product_url ? (
                  <a href={product_url} target="_blank" data-key="product_name">
                    {product_name}
                  </a>
                ) : (
                  <span data-key="product_name">{product_name}</span>
                )}
              </h1>

              <div className={styles.productSectionDetailsToggle}>
                <button
                  className={styles.productSectionDetailsToggleButton}
                  type="button"
                  onClick={this.toggleDetails}
                  data-translate={true}
                >
                  Product Info&nbsp;&nbsp;
                  <i className="fa fa-chevron-down" aria-hidden="true" />
                </button>
              </div>
            </div>
            {this.renderAttributes(this.props)}
          </div>
        </div>
        <div
          className={styles.productSectionDetails}
          hidden={!this.state.expanded}
        >
          <h3
            className={styles.productSectionDescriptionTitle}
            data-key="product_name"
          >
            {product_name}
          </h3>
          <p
            className={styles.productSectionDescription}
            data-key="product_description"
          >
            {product_description}
          </p>
          <table className={styles.productSectionMetaTable}>
            <tbody>
              {Boolean(brand_name) && (
                <tr>
                  <td
                    className={styles.productSectionMetaTableCell}
                    data-translate={true}
                  >
                    Brand
                  </td>
                  <td
                    className={styles.productSectionMetaTableCell}
                    data-key="brand_name"
                  >
                    {brand_name}
                  </td>
                </tr>
              )}
              {page_id && (
                <tr>
                  <td
                    className={styles.productSectionMetaTableCell}
                    data-translate={true}
                  >
                    Page ID
                  </td>
                  <td
                    className={styles.productSectionMetaTableCell}
                    data-key="page_id"
                  >
                    {page_id}
                  </td>
                </tr>
              )}
              {page_id_variant && (
                <tr>
                  <td
                    className={styles.productSectionMetaTableCell}
                    data-translate={true}
                  >
                    Page ID Variant
                  </td>
                  <td
                    className={styles.productSectionMetaTableCell}
                    data-key="page_id_variant"
                  >
                    {page_id_variant}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {associated_products.length > 0 && (
            <div className={styles.productSectionAssociated}>
              <h3 className={styles.productSectionDescriptionTitle} data-translate={true}>
                Associated Products ({associated_products.length})
              </h3>
              {associated_products.map(ap => (
                <div key={ap.page_id} className={styles.productSectionAssociatedItem}>
                  {ap.product_image_url && (
                    <img
                      src={ap.product_image_url}
                      alt={ap.product_name}
                      width="40"
                      height="40"
                      className={styles.productSectionAssociatedImage}
                    />
                  )}
                  <div>
                    <span data-key="product_name">{ap.product_name}</span>
                    <span className={styles.productSectionAssociatedPageId}>
                      Page ID: {ap.page_id}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductSection/ProductSection.js